import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// ================================
// KYC APIS (FormData-based)
// Controller: Kyccon.php
// ================================

// 1) Stats
export async function getKycStats(admin_id) {
  try {
    const fd = new FormData();
    fd.append("admin_id", admin_id);

    const res = await axios.post(`${apiBaseUrl}kyccon/get_kyc_stats`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 2) Listing
export async function getKycRequests(payload) {
  try {
    const fd = new FormData();

    fd.append("admin_id", payload.admin_id || "");
    fd.append("page_no", payload.page_no ?? 0);
    fd.append("keyword", payload.keyword || "");
    fd.append("status", payload.status || "");
    fd.append("doc_type", payload.doc_type || "");
    fd.append("sort_by", payload.sort_by || "NEWEST");

    const res = await axios.post(`${apiBaseUrl}kyccon/get_kyc_requests`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 3) Single KYC for preview
export async function getKycById(kycr_id) {
  try {
    const fd = new FormData();
    fd.append("kycr_id", kycr_id);

    const res = await axios.post(`${apiBaseUrl}kyccon/get_kyc_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 4) Approve
export async function approveKyc(kycr_id, admin_id) {
  try {
    const fd = new FormData();
    fd.append("kycr_id", kycr_id);
    fd.append("admin_id", admin_id);

    const res = await axios.post(`${apiBaseUrl}kyccon/approve_kyc`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 5) Reject
export async function rejectKyc(kycr_id, admin_id, reason) {
  try {
    const fd = new FormData();
    fd.append("kycr_id", kycr_id);
    fd.append("admin_id", admin_id);
    fd.append("reason", reason);

    const res = await axios.post(`${apiBaseUrl}kyccon/reject_kyc`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return res.data;
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

// 9) Export KYC Requests Excel
export async function exportKycRequestsXL(payload) {
  try {
    const fd = new FormData();

    fd.append("admin_id", payload.admin_id || "");
    fd.append("keyword", payload.keyword || "");
    fd.append("status", payload.status || "");
    fd.append("doc_type", payload.doc_type || "");
    fd.append("sort_by", payload.sort_by || "NEWEST");

    const res = await axios.post(`${apiBaseUrl}kyccon/export_kyc_requests_xl`, fd, {
      responseType: "blob",
      headers: { "Content-Type": "multipart/form-data" },
    });

    return { status: true, blob: res.data };
  } catch (err) {
    return { status: false, type: "danger", success: "Request Failed" };
  }
}

